module.exports = __webpack_public_path__ + "arrow_right.8ef6a08cdc1154920165.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/img/svg/arrow_right.svg
// module id = ../../../../angular-bootstrap-md/img/svg/arrow_right.svg
// module chunks = 3